import { CheckRounded } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import { ComplianceTypes } from '@/constants';
import { ComplianceType } from '@/types';
import { convertSecondsToMinutes } from '@/utils';

export const EthicsPill = ({
  color,
  ethicsDuration,
  compliance,
}: {
  color?: string;
  ethicsDuration?: number;
  compliance?: ComplianceType;
}) => (
  <Box
    sx={{
      display: 'flex',
      gap: 0.25,
      flexDirection: 'row',
      alignItems: 'center',
    }}>
    <CheckRounded
      sx={{ color: color ?? 'text.light', width: 13, height: 13 }}
    />
    <Typography variant="caption1Bold" color={color ?? 'text.light'}>
      Ethics
      {ethicsDuration && compliance !== ComplianceTypes.CPE
        ? ` ${convertSecondsToMinutes(ethicsDuration)} mins`
        : ''}
    </Typography>
  </Box>
);
